import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  LESSON_TYPES,
  editSbatGroupGroupContestModalStateSelector,
  findLessonByLessonType,
  setGroupContestModalState,
} from 'features/classCreation';
import EditGroupContestModalSidePanel from '../EditGroupContestModalSidePanel';
import Field from 'components/Field';
import Input from 'components/Input';
import InterviewbitTestDetails from '../InterviewbitTestDetails';
import SectionHeading from 'components/SectionHeading';
import styles from './EditGroupContestModal.module.scss';
import UpdateGroupContestButton from '../UpdateGroupContestButton';

function EditGroupContestModal({ sbatGroup }) {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(editSbatGroupGroupContestModalStateSelector);
  const { academy_topic: academyTopic } = sbatGroup;
  const { lessons } = academyTopic;
  const contestLesson = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.contest,
  });
  const { meta } = contestLesson;
  const { test_group_id: testGroupId } = meta;

  const handleModalClose = useCallback(() => {
    dispatch(setGroupContestModalState(false));
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleModalClose}
      size="extraLarge"
      className={styles.root}
      withoutHeader
    >
      <SectionHeading
        className={styles.sectionHeading}
        title="EDIT GROUP CONTEST"
        titleClassName={styles.heading}
      />
      <Field label="Contest Group ID">
        <div className="row space-between ">
          <Input
            disabled={true}
            value={testGroupId}
            className={styles.input}
          />
          <UpdateGroupContestButton sbatGroup={sbatGroup} />
        </div>
      </Field>
      <div className={styles.container}>
        <EditGroupContestModalSidePanel />
        <InterviewbitTestDetails />
      </div>
    </Modal>
  );
}

export default EditGroupContestModal;
